'use client'

import * as React from 'react'
import type { UseRefinementListProps } from 'react-instantsearch'
import { useRefinementList } from 'react-instantsearch'
import { tw } from 'utils/classnames'
import { Divider } from 'components/divider'
import { Checkbox } from 'primitives/cf-checkbox'

import { FilterAccordion } from './accordion'

export type SidebarFilterProps = Omit<UseRefinementListProps, 'attribute'> & {
  header: string
  attribute: string
  isExpanded?: boolean
  showMoreText: string
  showLessText: string
}

export function SidebarFilter(props: SidebarFilterProps) {
  const {
    showLessText,
    showMoreText,
    header,
    showMore = true,
    limit = 20,
    showMoreLimit = 999,
    attribute,
    isExpanded,
    ...useRefinementListProps
  } = props

  const refinementListApi = useRefinementList({
    showMore,
    showMoreLimit,
    limit,
    attribute,
    ...useRefinementListProps,
  })

  const { items, refine, canToggleShowMore, toggleShowMore, isShowingMore } = refinementListApi

  if (!items.length) {
    return null
  }

  const handleRefine = (value: string) => {
    refine(value)
  }

  const filterContent = (
    <div className="mt-5 flex flex-col">
      {items.map(
        (item, index) =>
          ((limit && index < limit) || isShowingMore) && (
            <div key={item.label + index} className="wrap text-14 flex items-center">
              <Checkbox
                value={item.value}
                label={
                  <>
                    <span className={tw(item.isRefined && 'font-semibold', 'capitalize')}>
                      {item.label}
                    </span>
                    <span className="text-12 ml-[5px] text-[#A0B2B8]">({item.count})</span>
                  </>
                }
                checked={item.isRefined}
                onClick={() => handleRefine(item.value)}
              />
            </div>
          ),
      )}
    </div>
  )

  return (
    <>
      <FilterAccordion header={header} expanded={isExpanded}>
        <div className="flex flex-col gap-[10px]">
          {filterContent}
          {showMore && limit && canToggleShowMore ? (
            <span
              className="text-12 cursor-pointer text-[#A0B2B8]"
              onClick={() => {
                toggleShowMore()
              }}
            >
              {isShowingMore ? showLessText : showMoreText}
            </span>
          ) : null}
        </div>
      </FilterAccordion>
      <Divider className="relative left-[-20px] w-[calc(100%+40px)] bg-[#DFDDE5]" />
    </>
  )
}
